import { SlicePipe } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { BasicFilter, Filter } from "@common/interfaces/filters.interfaces";

import { Plant } from "@models/Plant";

import { CharacteristicSearchService } from "@services/characteristic-search.service";

import { SidebarFilterActionsComponent } from "../sidebar-filter-actions/sidebar-filter-actions.component";

@Component({
  selector: "basic-filters",
  imports: [FormsModule, SidebarFilterActionsComponent, SlicePipe],
  templateUrl: "./basic-filters.component.html",
  styleUrls: ["./basic-filters.component.scss"]
})
export class BasicFiltersComponent {
  searchResults: Plant[];
  filterOptions: BasicFilter[];
  filterVisibilityMap: Map<string, boolean> = new Map<string, boolean>();

  checkboxes: string[] = [];
  checkedCount = 0;
  hasFiltersBeenApplied = false;

  filters: BasicFilter[];

  constructor(private characteristicSearchService: CharacteristicSearchService) {
    this.characteristicSearchService.otherFilters$.subscribe((filters: BasicFilter[]) => {
      this.filters = filters;
    });
  }

  updateCheckedCount(): void {
    this.hasFiltersBeenApplied = true;
    this.checkedCount = Object.values(this.checkboxes).filter(Boolean).length;
  }

  showMoreOrLessFilters(filterOption: BasicFilter): void {
    const isCurrentlyVisible = this.filterVisibilityMap.get(filterOption.name);
    this.filterVisibilityMap.set(filterOption.name, !isCurrentlyVisible);
  }

  getMoreFilters(filterOption: BasicFilter): Filter[] {
    const isCurrentlyVisible = this.filterVisibilityMap.get(filterOption.name);
    return isCurrentlyVisible ? filterOption.filters : filterOption.filters.slice(0, 5);
  }

  getMoreOrLessFiltersText(filterOption: BasicFilter): string {
    const isCurrentlyVisible = this.filterVisibilityMap.get(filterOption.name);
    return isCurrentlyVisible ? "Show Less" : "Show More";
  }

  getMoreOrLessFiltersClass(filterOption: BasicFilter): string {
    const isCurrentlyVisible = this.filterVisibilityMap.get(filterOption.name);
    return isCurrentlyVisible ? "fa fa-minus-square-o" : "fa fa-plus-square-o";
  }

  applyFilters(): void {
    const allPlantIds: number[] = this.filters.reduce((acc: number[], filterOption, j) => {
      filterOption.filters.forEach((filter: Filter, i: number) => {
        if (this.checkboxes[j + "-" + i]) {
          acc.push(...filter.plantIds);
        }
      });
      return acc;
    }, []);

    const uniquePlantIds = Array.from(new Set<number>(allPlantIds));
    this.characteristicSearchService.updateBasicFilterPlantIds(uniquePlantIds);
  }

  clearFilters(): void {
    this.checkboxes = [];
    this.checkedCount = 0;
    this.characteristicSearchService.clearBasicFilterPlantIds();
  }
}
